import { CompanyAPI } from '@api';

const checkPendingTerms = async () => CompanyAPI.checkPendingTerms()
  .then(({ data }) => data.has_pending_term_acceptances)
  .catch((error) => Promise.reject(error.response));

export { checkPendingTerms };
